import classNames from 'classnames'
import { type ReactDatePickerCustomHeaderProps } from 'react-datepicker'

import { EIcons } from '@/app/types/iconType'
import { Icon } from '@/shared/Icon'

import style from './CustomYearDropdown.module.scss'

export const CustomYearDropdown = ({
    date,
    changeYear,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled
}: ReactDatePickerCustomHeaderProps) => {
    const currentYear = new Date().getFullYear()
    const years = Array.from({ length: 201 }, (_, i) => currentYear - 100 + i)

    const monthNames = [
        'Январь',
        'Февраль',
        'Март',
        'Апрель',
        'Май',
        'Июнь',
        'Июль',
        'Август',
        'Сентябрь',
        'Октябрь',
        'Ноябрь',
        'Декабрь'
    ]

    return (
        <div className={style.container}>
            <button
                onClick={decreaseMonth}
                disabled={prevMonthButtonDisabled}
                className={classNames(style.btn, style.prevBtnWrapper)}
            >
                <Icon iconName={EIcons.AROW} color='#1F3447' />
            </button>
            <div className={style.monthNameWrapper}>
                <span>{monthNames[date.getMonth()]}</span>
            </div>
            <select value={date.getFullYear()} onChange={({ target: { value } }) => changeYear(Number(value))}>
                {years.map((option) => (
                    <option key={option} value={option}>
                        {option}
                    </option>
                ))}
            </select>

            <button
                onClick={increaseMonth}
                disabled={nextMonthButtonDisabled}
                className={classNames(style.btn, style.nextBtnWrapper)}
            >
                <Icon iconName={EIcons.AROW} color='#1F3447' />
            </button>
        </div>
    )
}
